(function () {
    'use strict';

    angular.module('sempraWebapp').controller('SavingsGroupDetailsController', SavingsGroupDetailsController);

    /** @ngInject */
    function SavingsGroupDetailsController($stateParams, $state, $mdDialog, $filter, userGroupActions, exportToCsv) {
        var vm = this;

        // Group info
        vm.groupId = $stateParams.groupId;
        vm.group = null;
        vm.isLoading = true;

        // Date range filter
        vm.dateFrom = new Date(new Date().setMonth(new Date().getMonth() - 1)); // Default: last month
        vm.dateTo = new Date();
        vm.maxDate = new Date();

        // User spending data (mock)
        vm.userSpending = [];
        vm.allUserSpending = []; // Store all data before filtering

        // Pagination
        vm.pagination = {
            page: 1,
            pageSize: 10,
            total: 0,
            pageOptions: [10, 25, 50]
        };

        // Functions
        vm.goBack = goBack;
        vm.pageChanged = pageChanged;
        vm.getTotalSpent = getTotalSpent;
        vm.getTotalTopups = getTotalTopups;
        vm.getTotalBalance = getTotalBalance;
        vm.applyDateFilter = applyDateFilter;
        vm.onDateFromChange = onDateFromChange;
        vm.onDateToChange = onDateToChange;
        vm.showUserTransactions = showUserTransactions;
        vm.exportToCsvReport = exportToCsvReport;

        // Initialize
        activate();

        function activate() {
            loadGroupDetails();
            loadUserSpending();
        }

        function loadGroupDetails() {
            userGroupActions.getUserGroupById(vm.groupId).then(function (group) {
                vm.group = group;
            }).catch(function (error) {
                console.error('Error loading group details:', error);
            });
        }

        function loadUserSpending() {
            vm.isLoading = true;
            
            // Format dates for API call
            var dateFromStr = formatDateForApi(vm.dateFrom);
            var dateToStr = formatDateForApi(vm.dateTo);
            
            userGroupActions.getUserGroupSpending(vm.groupId, dateFromStr, dateToStr).then(function (data) {
                vm.userSpending = data || [];
                vm.pagination.total = vm.userSpending.length;
                vm.pagination.page = 1;
                vm.isLoading = false;
            }).catch(function (error) {
                console.error('Error loading user spending:', error);
                vm.userSpending = [];
                vm.isLoading = false;
            });
        }

        function formatDateForApi(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        }

        function applyDateFilter() {
            loadUserSpending();
        }

        function onDateFromChange() {
            if (vm.dateFrom && vm.dateTo && vm.dateFrom > vm.dateTo) {
                vm.dateTo = new Date(vm.dateFrom);
            }
        }

        function onDateToChange() {
            if (vm.dateFrom && vm.dateTo && vm.dateTo < vm.dateFrom) {
                vm.dateFrom = new Date(vm.dateTo);
            }
        }

        function goBack() {
            $state.go('app.savings', { tab: 1 });
        }

        function exportToCsvReport() {
            if (!vm.userSpending || vm.userSpending.length === 0) {
                return;
            }

            var csvData = vm.userSpending.map(function (user) {
                return {
                    'User ID': user.savingsUserId,
                    'Total Spent': user.totalSpent ? user.totalSpent.toFixed(2) : '0.00',
                    'Currency': user.currency || 'EUR',
                    'Transactions': user.transactionCount || 0,
                    'Last Transaction': user.lastTransaction ? $filter('date')(user.lastTransaction, 'dd.MM.yyyy HH:mm') : '-'
                };
            });

            var groupName = vm.group ? vm.group.name : 'SavingsGroup';
            var dateFrom = $filter('date')(vm.dateFrom, 'dd-MM-yyyy');
            var dateTo = $filter('date')(vm.dateTo, 'dd-MM-yyyy');
            var fileName = groupName + '_' + dateFrom + '_' + dateTo + '.csv';

            exportToCsv.exportBasicArrayToCsv(csvData, fileName);
        }

        function pageChanged(page, limit) {
            vm.pagination.page = page;
            vm.pagination.pageSize = limit;
        }

        function getTotalSpent() {
            return vm.userSpending.reduce(function (sum, user) {
                return sum + user.totalSpent;
            }, 0);
        }

        function getTotalTopups() {
            return vm.userSpending.reduce(function (sum, user) {
                return sum + user.totalTopups;
            }, 0);
        }

        function getTotalBalance() {
            return vm.userSpending.reduce(function (sum, user) {
                return sum + user.remainingBalance;
            }, 0);
        }

        function showUserTransactions(user) {
            // Get date range for filtering
            var dateFromStr = formatDateForApi(vm.dateFrom);
            var dateToStr = formatDateForApi(vm.dateTo);

            userGroupActions.getUserTransactions(vm.groupId, user.savingsUserId, dateFromStr, dateToStr).then(function (transactions) {
                $mdDialog.show({
                    controller: UserTransactionsDialogController,
                    controllerAs: 'dialog',
                    templateUrl: 'app/savings/savingsUserTransactionsDialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        user: user,
                        transactions: transactions || []
                    }
                });
            }).catch(function (error) {
                console.error('Error loading user transactions:', error);
                // Show dialog with empty transactions on error
                $mdDialog.show({
                    controller: UserTransactionsDialogController,
                    controllerAs: 'dialog',
                    templateUrl: 'app/savings/savingsUserTransactionsDialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        user: user,
                        transactions: []
                    }
                });
            });
        }

        /** @ngInject */
        function UserTransactionsDialogController($mdDialog, user, transactions) {
            var dialog = this;
            dialog.user = user;
            dialog.transactions = transactions;

            dialog.close = function () {
                $mdDialog.hide();
            };
        }
    }
})();
